import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';

export const useUserUtils = () => {
  const [{ user }] = useStore() as unknown as UseStoreValues;

  const isStaffUser = (): boolean => Boolean(user?.is_staff);

  const isSuperUser = (): boolean => Boolean(user?.is_superuser);

  // Who may delete or accept citations. Mirrors the StaffPermission the citation
  // endpoints enforce, so the UI never offers a control the server refuses.
  const canReviewCitations = (): boolean => isStaffUser() || isSuperUser();

  return {
    canReviewCitations,
    isStaffUser,
    isSuperUser,
    user,
  };
};
